// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__541Lt","description":"NotFoundBlock_description__+0RwA"};